import { render, staticRenderFns } from "./PortcallclearancesstatusModals.vue?vue&type=template&id=4f548f44"
import script from "./PortcallclearancesstatusModals.vue?vue&type=script&lang=js"
export * from "./PortcallclearancesstatusModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports